<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('cuadros')">Cuadro </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Día {{ cuadro[1].dia }}
    </h1>
    <trashed-message v-if="cuadro.deleted_at" class="mb-6" @restore="restore">
      This cuadro has been deleted.
    </trashed-message>
      <div v-for="cuadrop in form.cuadroarray" :key="cuadrop.id">
        <div  class="bg-white rounded-md shadow overflow-hidden max-w-8xl">
        <form @submit.prevent="update(cuadrop.id)">
            <div  class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="cuadrop.origen" class="pr-6 pb-8 w-full lg:w-1/6" label="Origen" required>
            <option v-for="origen in origenes" :key="origen.index">{{origen.origen}}</option>
          </select-input> 
          <select-input v-model="cuadrop.destino" class="pr-6 pb-8 w-full lg:w-1/6" label="Destino" required>
            <option v-for="destino in destinos" :key="destino.index">{{destino.destino}}</option>
          </select-input> 
          <text-input v-model="cuadrop.hora" class="pr-6 pb-8 w-full lg:w-1/6"   label="Hora" />
          <text-input v-model="cuadrop.despacho" class="pr-6 pb-8 w-full lg:w-1/6"   label="Despacho" />
          <text-input v-model="cuadrop.detalle" class="pr-6 pb-8 w-full lg:w-2/6"   label="detalle" />
            </div>
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
              <button v-if="$page.props.auth.user.rol == 'Admin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar</button>
              <loading-button v-if="$page.props.auth.user.rol =='Admin' " :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar</loading-button>
            </div>
         
      </form> 
    </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return { title: 'CRM' }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    cuadro: Array,
    origenes: Array,
    destinos: Array
  },
  remember: 'form',
  data() {
    return {
      
      form: this.$inertia.form({
        cuadroarray: this.cuadro,
        
      }),
    }
  },
  methods: {
    update(index) {
      this.form.put(this.route('cuadros.update',index))
    },
    destroy() {
      if (confirm('Quiere Borrar del Cuadro General?')) {
        this.$inertia.delete(this.route('cuadros.destroy', this.cuadro.id))
      }
    },
  },
}
</script>
